/* Advertorial — layout adv-v4 "story article". JS namespace: lpa4.
   The export's only script switched the button colour (a designer's tweak),
   so nothing of it is carried over. One behaviour here: a link that points at
   the offer box (#offer, used when a button has no link of its own) scrolls
   there smoothly. Rebinds on shopify:section:load so the editor does not
   double-bind. */
(function () {
  'use strict';
  var lpa4 = {
    bound: false,
    onClick: function (e) {
      var a = e.target.closest ? e.target.closest('.lp4-adv a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var target = id && document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    init: function () {
      if (lpa4.bound) return;
      document.addEventListener('click', lpa4.onClick);
      lpa4.bound = true;
    }
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', lpa4.init);
  } else {
    lpa4.init();
  }
  document.addEventListener('shopify:section:load', lpa4.init);
})();
